import { useState } from 'react'
import { cn } from '@/lib/utils'
import { ChevronDown } from 'lucide-react'

interface AccordionItem {
  id: string
  title: string
  content: React.ReactNode
}

interface AccordionProps {
  items: AccordionItem[]
  className?: string
}

export function Accordion({ items, className }: AccordionProps) {
  const [openId, setOpenId] = useState<string | null>(null)

  return (
    <div className={cn('divide-y divide-ink/10 border-b border-t border-ink/10', className)}>
      {items.map((item) => {
        const isOpen = openId === item.id
        return (
          <div key={item.id}>
            <button
              type="button"
              onClick={() => setOpenId(isOpen ? null : item.id)}
              className="flex w-full items-center justify-between py-4 text-left text-carbon transition-colors hover:text-wd-orange"
              aria-expanded={isOpen}
            >
              <span className="font-sans text-lg font-medium uppercase tracking-[0.12em] leading-tight">{item.title}</span>
              <ChevronDown
                className={cn(
                  'h-5 w-5 text-carbon/40 transition-transform duration-300',
                  isOpen && 'rotate-180'
                )}
              />
            </button>
            {isOpen && (
              <div className="pb-5 leading-relaxed text-carbon/60">{item.content}</div>
            )}
          </div>
        )
      })}
    </div>
  )
}
